import { enableProdMode, importProvidersFrom } from "@angular/core";
import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { appRoutes } from "./app/app.routes";
import { ApiModule as HusbankenApplicationTemplateApi } from "../projects/api/api.module";
import { ApiModule as BrukerApi } from "@husbanken/bruker-api";
import { registerLocaleData } from "@angular/common";
import { bootstrapApplication } from "@angular/platform-browser";
import { fetchAppConfig, fetchKeycloakConfig, provideHusbanken, provideTranslations as provideFrontendStarterTranslations } from "@husbanken/frontend-starter";
import { provideTranslations as provideCoreTranslations } from "@husbanken/designsystem-angular-core";
import { provideTranslations as provideFormsTranslations } from "@husbanken/designsystem-angular-forms";
import { provideTranslations as provideHeaderTranslations } from "@husbanken/designsystem-angular-header-v2";
import localeFrNb from "@angular/common/locales/nb";
import "./app/core/types/frontend-starter";

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeFrNb);

async function bootstrap(): Promise<void> {
  const appConfig = await fetchAppConfig(environment.appConfigUri as string);
  const keycloakConfig = await fetchKeycloakConfig(environment.keycloakConfigUri as string);

  try {
    await bootstrapApplication(AppComponent, {
      providers: [
        provideHusbanken(
          {
            ...appConfig,
            authConfig: { keycloakConfig },
            i18nConfig: {
              useStaticLoader: true,
              extras: [provideCoreTranslations(), provideFormsTranslations(), provideHeaderTranslations(), provideFrontendStarterTranslations()],
            },
            clientLoggerConfig: {
              clientLoggerUri: "/klientlogger/log/felles-template-application",
            },
            routingConfig: {
              routes: appRoutes,
            },
          },
          {
            features: {
              clientLogger: false,
            },
            extras: [importProvidersFrom(BrukerApi.forRoot({ rootUrl: "api" }), HusbankenApplicationTemplateApi.forRoot({ rootUrl: "api" }))],
          },
        ),
      ],
    });
  } catch (error) {
    console.error("Failed to initialize the application", error);
  }
}

bootstrap();
